import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var DataService = /** @class */ (function () {
    function DataService() {
        this.messageSource = new BehaviorSubject('default message');
        this.membershipSource = new BehaviorSubject('default message');
        this.userRoleSource = new BehaviorSubject('default message');
        this.bpgListSource = new BehaviorSubject('default message');
        this.eventsViewDetailsSource = new BehaviorSubject('default message');
        // private eventEditDataSource = new BehaviorSubject(null);
        this.expenseEditDataSource = new BehaviorSubject(null);
        this.navigationBpgListSource = new BehaviorSubject('default message');
        this.claimExpense = new BehaviorSubject(null);
        this.siteIdAndPathSource = new BehaviorSubject('default message');
        this.eventDateSource = new BehaviorSubject('null');
        this.selectedEventDataSourceSource = new BehaviorSubject('null');
        //private siteIdBpgIdAndPathSource = new BehaviorSubject('default message');
        this.messageApproveSource = new BehaviorSubject('default message');
        this.budgetDateSource = new BehaviorSubject(null);
        this.selectedMyBpgsDataSource = new BehaviorSubject('default message');
        this.selectedSiteIdSource = new BehaviorSubject('default message');
        this.selectedSiteIdForSiteMenuSource = new BehaviorSubject('default message');
        this.selectedNaacIdForNaacMenuSource = new BehaviorSubject('default message');
        this.folderSectionSource = new BehaviorSubject('null');
        this.isEventPopupOpenedSource = new BehaviorSubject(null);
        this.setBannerSource = new BehaviorSubject(null);
        this.savedMembershipForm = this.membershipSource.asObservable();
        this.savedData = this.messageSource.asObservable();
        this.userRoleData = this.userRoleSource.asObservable();
        this.bpgListData = this.bpgListSource.asObservable();
        this.selectedEventsDetails = this.eventsViewDetailsSource.asObservable();
        this.selectedBpgList = this.navigationBpgListSource.asObservable();
        //eventEditData = this.eventEditDataSource.asObservable();
        this.expenseEditData = this.expenseEditDataSource.asObservable();
        this.claimExpenseData = this.claimExpense.asObservable();
        this.siteIdAndPath = this.siteIdAndPathSource.asObservable();
        this.eventDate = this.eventDateSource.asObservable();
        //siteIdBpgIdAndPath = this.siteIdBpgIdAndPathSource.asObservable();
        this.eventViewApprove = this.messageApproveSource.asObservable();
        this.claimExpenseApprove = this.messageApproveSource.asObservable();
        this.eventData = this.selectedEventDataSourceSource.asObservable();
        this.budgetData = this.budgetDateSource.asObservable();
        this.myBpgsData = this.selectedMyBpgsDataSource.asObservable();
        this.selectedSiteId = this.selectedSiteIdSource.asObservable();
        this.selectedSiteIdForSiteNavMenu = this.selectedSiteIdForSiteMenuSource.asObservable();
        this.selectedNaacIdForNaacMenu = this.selectedNaacIdForNaacMenuSource.asObservable();
        this.folderSection = this.folderSectionSource.asObservable();
        this.isEventPopupOpened = this.isEventPopupOpenedSource.asObservable();
        this.isBanner = this.setBannerSource.asObservable();
    }
    DataService.prototype.saveData = function (message) {
        this.messageSource.next(message);
    };
    DataService.prototype.userRoleDetails = function (message) {
        this.userRoleSource.next(message);
    };
    DataService.prototype.bpgList = function (message) {
        this.bpgListSource.next(message);
    };
    DataService.prototype.showSavedMembershipForm = function (message) {
        this.membershipSource.next(message);
    };
    DataService.prototype.getSelectedEventDetails = function (message) {
        console.log(message);
        this.eventsViewDetailsSource.next(message);
    };
    // setEditEventData(message: any) {
    //   this.eventEditDataSource.next(message);
    // }
    DataService.prototype.selectedNavigationBpgs = function (message) {
        console.log(message);
        this.navigationBpgListSource.next(message);
    };
    DataService.prototype.selectedSiteIdAndPath = function (message) {
        this.siteIdAndPathSource.next(message);
    };
    // selectedSiteIdBpgIdAndPath(message: any) {
    //   this.siteIdBpgIdAndPathSource.next(message);
    // }
    DataService.prototype.setSelectedEventDate = function (message) {
        this.eventDateSource.next(message);
    };
    DataService.prototype.setselectedEventInfo = function (message) {
        this.selectedEventDataSourceSource.next(message);
    };
    // selectedSiteIdBpgIdAndPath(message:any){
    //   this.siteIdBpgIdAndPathSource.next(message);
    // }
    DataService.prototype.saveClaimData = function (data) {
        this.claimExpense.next(data);
    };
    DataService.prototype.setApproved = function (message) {
        this.messageApproveSource.next(message);
    };
    DataService.prototype.setEditExpenceData = function (message) {
        this.expenseEditDataSource.next(message);
    };
    DataService.prototype.saveBudget = function (message) {
        this.budgetDateSource.next(message);
    };
    DataService.prototype.setMyBpgSiteIdAndBpgId = function (message) {
        this.selectedMyBpgsDataSource.next(message);
    };
    DataService.prototype.setSiteId = function (message) {
        this.selectedSiteIdSource.next(message);
    };
    DataService.prototype.selectedSiteIdForSiteMenu = function (message) {
        this.selectedSiteIdForSiteMenuSource.next(message);
    };
    DataService.prototype.selectednaacIdForNaacMenu = function (message) {
        this.selectedNaacIdForNaacMenuSource.next(message);
    };
    DataService.prototype.folderSections = function (message) {
        this.folderSectionSource.next(message);
    };
    DataService.prototype.setEventPopupOpened = function (message) {
        this.isEventPopupOpenedSource.next(message);
    };
    DataService.prototype.setBanner = function (message) {
        this.setBannerSource.next(message);
    };
    DataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(); }, token: DataService, providedIn: "root" });
    return DataService;
}());
export { DataService };
var bpgs = /** @class */ (function () {
    function bpgs() {
    }
    return bpgs;
}());
export { bpgs };
var interests = /** @class */ (function () {
    function interests() {
    }
    return interests;
}());
export { interests };
var skills = /** @class */ (function () {
    function skills() {
    }
    return skills;
}());
export { skills };
var leadership = /** @class */ (function () {
    function leadership() {
    }
    return leadership;
}());
export { leadership };
var demographics = /** @class */ (function () {
    function demographics() {
    }
    return demographics;
}());
export { demographics };
var site = /** @class */ (function () {
    function site() {
    }
    return site;
}());
export { site };
var membershipFormData = /** @class */ (function () {
    function membershipFormData() {
    }
    return membershipFormData;
}());
export { membershipFormData };
var membershipDetails = /** @class */ (function () {
    function membershipDetails() {
        this.bpgIds = [];
        this.skillIds = [];
        this.areaOfImpactIds = [];
        this.demographicIds = [];
    }
    return membershipDetails;
}());
export { membershipDetails };
var membershipData = /** @class */ (function () {
    function membershipData() {
        this.bpgIds = [];
        this.skillIds = [];
        this.areaOfImpactIds = [];
        this.demographicIds = [];
    }
    return membershipData;
}());
export { membershipData };
var LandingDTOModel = /** @class */ (function () {
    function LandingDTOModel() {
        this.page = 0;
        this.presentRole = '-';
        this.searchTerm = '';
        this.size = 0;
        this.sortDirection = 'ASC';
        this.sortProperty = '-';
        this.uid = '-';
    }
    return LandingDTOModel;
}());
export { LandingDTOModel };
var FilterModel = /** @class */ (function () {
    function FilterModel() {
    }
    return FilterModel;
}());
export { FilterModel };
var Budget = /** @class */ (function () {
    function Budget() {
        this.affinityGoals = "";
        this.chapterGoals = "";
        this.chapterName = "";
        this.siteName = "";
        this.budgetStatus = "";
        this.budgetAllocatedDate = null;
        this.budgetAllocatedBy = "";
        this.comment = "";
        this.budgetSource = "";
        this.budgetRequestedDate = null;
    }
    return Budget;
}());
export { Budget };
var Amount = /** @class */ (function () {
    function Amount() {
    }
    return Amount;
}());
export { Amount };
var Hoshin = /** @class */ (function () {
    function Hoshin() {
        this.bpgInitiative = "";
        this.businessDrivers = "";
        this.actionPlan = "";
        this.kpi = "";
        this.estimatedTiming = "";
        this.midYearResults = "";
        this.yearEndResults = "";
        this.challenges = "";
        this.supportingDoc1 = "";
        this.leadAdminApprovalComment = "";
        this.superAdminApprovalComment = "";
        this.hoshinSubmitDate = null;
        this.leadAdminApprovedDate = null;
        this.superAdminApprovedDate = null;
        this.name = "";
        this.budgetType = "";
        this.createdBy = "";
        this.modifiedBy = "";
        this.status = "";
        this.frequency = "";
        this.lead1Name = "";
        this.lead2Name = "";
        this.baseHoshinExists = "";
        this.additionalFunding = "";
        this.additionalFundingSource = "";
        this.evaluation = "";
    }
    return Hoshin;
}());
export { Hoshin };
var BudgetHoshin = /** @class */ (function () {
    function BudgetHoshin() {
    }
    return BudgetHoshin;
}());
export { BudgetHoshin };
/* Survey Response */
var Employee = /** @class */ (function () {
    function Employee() {
    }
    return Employee;
}());
export { Employee };
var SurveyQuestion = /** @class */ (function () {
    function SurveyQuestion() {
    }
    return SurveyQuestion;
}());
export { SurveyQuestion };
var SurveyAnswer = /** @class */ (function () {
    function SurveyAnswer() {
    }
    return SurveyAnswer;
}());
export { SurveyAnswer };
var TakeSurvey = /** @class */ (function () {
    function TakeSurvey() {
        this.comments = "";
        this.modifiedBy = "";
        this.createdBy = "";
        this.surveyTakenUserName = "";
    }
    return TakeSurvey;
}());
export { TakeSurvey };
var SurveyMaster = /** @class */ (function () {
    function SurveyMaster() {
        this.surveryDesc = "";
        this.startDate = new Date();
        this.endDate = new Date();
    }
    return SurveyMaster;
}());
export { SurveyMaster };
var SitePrimaryContactDTO = /** @class */ (function () {
    function SitePrimaryContactDTO() {
        this.createdBy = "";
        this.createdDateTime = null;
        this.sitePrimaryContactId = null;
    }
    return SitePrimaryContactDTO;
}());
export { SitePrimaryContactDTO };
var SuveyTakenByUserDTO = /** @class */ (function () {
    function SuveyTakenByUserDTO() {
    }
    return SuveyTakenByUserDTO;
}());
export { SuveyTakenByUserDTO };
/*Pagination DTO */
var LandingPaginationDTO = /** @class */ (function () {
    function LandingPaginationDTO() {
        this.moduleId = 0;
        this.page = 0;
        this.presentRole = '';
        this.searchTerm = '';
        this.size = 0;
        this.sortDirection = '';
        this.sortProperty = '';
        this.uid = '';
    }
    return LandingPaginationDTO;
}());
export { LandingPaginationDTO };
